import React from 'react';
import CrudPage from '../../../components/CrudPage';
import { AUDIT_COLUMNS } from '../../../config/columns';
import { nationalityService } from '../../../services/resources';

export default function NationalityPage({ onToast }) {
  return (
    <CrudPage
      title="Nationality"
      formCode="NATIONALITY"
      service={nationalityService}
      onToast={onToast}
      searchKeys={['nationality_code', 'nationality_name']}
      columns={[
        { key: 'nationality_code', label: 'Code' },
        { key: 'nationality_name', label: 'Name' },
        ...AUDIT_COLUMNS,
      ]}
      fields={[
        { key: 'nationality_code', label: 'Code', type: 'text', required: true, immutableOnEdit: true, uppercase: true },
        { key: 'nationality_name', label: 'Name', type: 'text', required: true },
      ]}
    />
  );
}
